import { createAsyncThunk } from '@reduxjs/toolkit';
import apiServices from '../services/service';
import UsersWithRMName from '../shared/controls/methods/getFinalUserWithRMName';

export const fetchFinalDataWithRMName = createAsyncThunk(
  'lists/fetchFinalDataWithRMName',
  async (list, thunkAPI) => {
    try {
      if (list.key === 'fetchFinalDataWithRMName') {
        return await UsersWithRMName(list.inputData);
      }
    } catch (error) {
      throw error;
    }
  }
);

export const fetchDataAndUpdateStore = createAsyncThunk(
  'lists/fetchDataAndUpdateStore',
  async (list, thunkAPI) => {
    try {
      switch (list.key) {
        case 'user':
          return await apiServices.getUserDetailByMailOrOid(...list.inputData);
        case 'userInfo':
          return await apiServices.getUserDetail(list.inputData);
        case 'genericMasterFilteredList':
          return await apiServices.getGenericMasterFilteredList(list.inputData);
        case 'productReferenceLookup':
          return await apiServices.getProductReferenceLookup(list.inputData);
        case 'owners':
          return await apiServices.getUserList();
        case 'userActivity':
          return await apiServices.getUserActivity(list.inputData);
        // case "leadTag":
        //   let leadTag = await apiServices.getTagsByModule({ module: ["Lead"] });
        //   leadTag.data["tags"] = tags?.data?.tags;
        //   return leadTag;
        case 'tagsByModule':
          const tags = await apiServices.getTagsByModule({
            module: [list.inputData],
          });

          return tags;

        case 'leads':
          // const tags = await apiServices.getTagsByModule({ module: ["Lead"] });
          let leadData = await apiServices.getLeadList(list.inputData);
          // leadData.data["tags"] = tags?.data?.tags;
          leadData.data['inputPayload'] = list.inputData;
          return leadData;
        case "attendanceByUserId":
          return await apiServices.getAttendanceByUserId(list.inputData);  
        // return await apiServices.getLeadList(list.inputData);
        case 'campaignList':
          // const campaignTags = await apiServices.getTagsByModule({
          //   module: ["Campaign"],
          // });
          let campaignData = await apiServices.getCampaignList(list.inputData);
          // campaignData.data["tags"] = campaignTags?.data?.tags;
          campaignData.data['inputPayload'] = list.inputData;
          return campaignData;
        case 'contactList':
          // const contactTags = await apiServices.getTagsByModule({
          //   module: ["Contact"],
          // });
          let contactData = await apiServices.getContactList(list.inputData);
          // contactData.data["tags"] = contactTags?.data?.tags;
          contactData.data['inputPayload'] = list.inputData;
          return contactData;
        case 'accountList':
          // const accountTags = await apiServices.getTagsByModule({
          //   module: ["Account"],
          // });
          let accountData = await apiServices.getAccountList(list.inputData);
          // accountData.data["tags"] = accountTags?.data?.tags;
          accountData.data['inputPayload'] = list.inputData;
          return accountData;
        case 'salutation':
          return await apiServices.getSalutation();
        case 'contactPersonRole':
          return await apiServices.getContactPersonRole();
        case 'stage':
          return await apiServices.getStage();
        case 'campaignSource':
          return await apiServices.getCampaignSource();
        case 'campaignMemberStatus':
          return await apiServices.getCampaignMemberStatus();
        case 'ticketStatus':
          return await apiServices.getTicketStatus();
        case 'campaignType':
          return await apiServices.getCampaignType();
        case 'campaignStatus':
          return await apiServices.getCampaignStatus();
        case 'ticketPriority':
          return await apiServices.getTicketPriority();
        case 'forecastCategory':
          return await apiServices.getForecastCategory();
        case 'projectTypeCrm':
          return await apiServices.getProjectTypeCrm();
        case 'revenueTypeList':
          return await apiServices.getRevenueTypeList();
        case 'leadSourceList':
          return await apiServices.getLeadSourceList();
        case 'industryList':
          return await apiServices.getIndustryList();
        case 'accountType':
          return await apiServices.getAccountType();
        case 'timeZone':
          return await apiServices.getTimeZone();
        case 'meetingsList':
          return await apiServices.getMeetingsList(list.inputData);
        case 'userList':
          return await apiServices.getUserList();
        // case "opportunityList":
        //   return await apiServices.getOpportunityList(list.inputData);
        case 'opportunityList':
          // const opportunityTags = await apiServices.getTagsByModule({
          //   module: ["Opportunity"],
          // });
          let opportunityData = await apiServices.getOpportunityList(list.inputData);
          // opportunityData.data["tags"] = opportunityTags?.data?.tags;
          opportunityData.data['inputPayload'] = list.inputData;
          return opportunityData;
        // case "ticketList":
        //   return await apiServices.getTicketList(list.inputData);
        case 'ticketList':
          let ticketData = await apiServices.getTicketList(list.inputData);
          ticketData.data['inputPayload'] = list.inputData;
          return ticketData;
        case 'callsList':
          return await apiServices.getCallsList(list.inputData);
        case 'template':
          return await apiServices.getAllTemplate();
        case 'accountDropdown':
          return await apiServices.getAccountsDropdown(list.inputData);
        case 'leadDropdown':
          return await apiServices.getLeadsDropdown(list.inputData);
        case 'contactDropdown':
          return await apiServices.getContactsDropdown(list.inputData);
        case 'opportunityDropdown':
          return await apiServices.getOpportunityDropdown(list.inputData);
        case 'campaignDropdownLead':
          return await apiServices.getCampaignDropdown(list.inputData);
        case 'campaignDropdownContact':
          return await apiServices.getCampaignDropdown(list.inputData);
        case 'productDropdown':
          return await apiServices.getProductDropdown(list.inputData);
        case 'massEmailLeadSent':
          let massEmailLeadSent = await apiServices.getMassEmailsByModule(list.inputData);
          massEmailLeadSent.data['inputPayload'] = list.inputData;
          return massEmailLeadSent;
        case 'massEmailLeadSchedule':
          let massEmailLeadSchedule = await apiServices.getMassEmailsByModule(list.inputData);
          massEmailLeadSchedule.data['inputPayload'] = list.inputData;
          return massEmailLeadSchedule;
        case 'massEmailContactSent':
          let massEmailContactSent = await apiServices.getMassEmailsByModule(list.inputData);
          massEmailContactSent.data['inputPayload'] = list.inputData;
          return massEmailContactSent;
        case 'massEmailContactSchedule':
          let massEmailContactSchedule = await apiServices.getMassEmailsByModule(list.inputData);
          massEmailContactSchedule.data['inputPayload'] = list.inputData;
          return massEmailContactSchedule;

        case 'quoteList':
          let quoteList = await apiServices.getQuoteList(list.inputData);
          quoteList.data['inputPayload'] = list.inputData;
          return quoteList;
        case 'salesOrder':
          let salesOrder = await apiServices.getSalesOrder(list.inputData);
          salesOrder.data['inputPayload'] = list.inputData;
          return salesOrder;

        case 'invoice':
          let invoice = await apiServices.getInvoice(list.inputData);
          invoice.data['inputPayload'] = list.inputData;
          return invoice;

        case 'productList':
          let productList = await apiServices.getProductList(list.inputData);
          productList.data['inputPayload'] = list.inputData;
          return productList;

        case 'priceSheetList':
          let priceSheetList = await apiServices.getPriceList(list.inputData);
          priceSheetList.data['inputPayload'] = list.inputData;
          return priceSheetList;
        case 'smartSequence':
          let smartSequence = await apiServices.getSmartSequence(list.inputData);
          smartSequence.data['inputPayload'] = list.inputData;
          return smartSequence;
        case 'zohoCampaigns':
          return await apiServices.getZohoCampaigns();
        case 'auditLogs':
          let auditLogs = await apiServices.getAuditLogs(list.inputData);
          auditLogs.data['inputPayload'] = list.inputData;
          return auditLogs;
        default:
          return { data: [] };
      }
    } catch (error) {
      throw error;
    }
  }
);

export const fetchRemainingData = createAsyncThunk(
  'lists/fetchRemainingData',
  async (list, thunkAPI) => {
    let data = list.initialData || [];
    let response;
    try {
      switch (list.key) {
        case 'projects':
          do {
            response = await apiServices.getSortedProjectList({
              ...list.inputData,
              PageNumber: list.pageNumber || 1, // Use the pageNumber property for projects
            });

            if (response.status === 200) {
              // Check if the response contains projects data
              if (response.data.projects && response.data.projects.length > 0) {
                const newProjects = response.data.projects.filter(
                  (project) => !data.some((existingProject) => existingProject.id === project.id)
                );

                // Concatenate filtered new projects to existing data
                data = [...data, ...newProjects];

                // Increment PageNumber for the next iteration
                list.pageNumber = (list.pageNumber || 1) + 1; // Increment pageNumber for projects
              } else {
                // No more projects available, break out of the loop
                break;
              }
            } else {
              // Handle API error here
              throw new Error('Failed to fetch projects: ' + response.statusText);
            }
          } while (response.data.projects.length >= list.inputData.PageSize);

          // Update the response data with the aggregated projects data
          response.data.projects = data;
          return response;

        case 'milestones':
          do {
            response = await apiServices.getSortedMilestoneList({
              ...list.inputData,
              PageNumber: list.pageNumber || 1, // Use the pageNumber property for milestones
            });

            if (response.status === 200) {
              // Check if the response contains milestones data
              if (response.data.milestones && response.data.milestones.length > 0) {
                const newMilestones = response.data.milestones.filter(
                  (milestone) =>
                    !data.some((existingMilestone) => existingMilestone.id === milestone.id)
                );

                // Concatenate filtered new milestones to existing data
                data = [...data, ...newMilestones];

                // Increment PageNumber for the next iteration
                list.pageNumber = (list.pageNumber || 1) + 1; // Increment pageNumber for milestones
              } else {
                // No more milestones available, break out of the loop
                break;
              }
            } else {
              // Handle API error here
              throw new Error('Failed to fetch milestones: ' + response.statusText);
            }
          } while (response.data.milestones.length >= list.inputData.PageSize);

          // Update the response data with the aggregated milestones data
          response.data.milestones = data;
          return response;

        case 'assignments':
          do {
            response = await apiServices.getSortedTaskList({
              ...list.inputData,
              PageNumber: list.pageNumber || 1, // Use the pageNumber property for assignments
            });

            if (response.status === 200) {
              // Check if the response contains assignments data
              if (response.data.assignments && response.data.assignments.length > 0) {
                const newAssignments = response.data.assignments.filter(
                  (assignment) =>
                    !data.some((existingAssignment) => existingAssignment.id === assignment.id)
                );

                // Concatenate filtered new assignments to existing data
                data = [...data, ...newAssignments];

                // Increment PageNumber for the next iteration
                list.pageNumber = (list.pageNumber || 1) + 1; // Increment pageNumber for assignments
              } else {
                // No more assignments available, break out of the loop
                break;
              }
            } else {
              // Handle API error here
              throw new Error('Failed to fetch assignments: ' + response.statusText);
            }
          } while (response.data.assignments.length >= list.inputData.PageSize);

          // Update the response data with the aggregated assignments data
          response.data.assignments = data;
          return response;
        case 'timesheets':
          do {
            response = await apiServices.getSortedTimesheetList({
              ...list.inputData,
              PageNumber: list.pageNumber || 1, // Use the pageNumber property for timesheets
            });
            if (response.status === 200) {
              // Check if the response contains timesheets data
              if (response.data.timesheets && response.data.timesheets.length > 0) {
                const newTimesheet = response.data.timesheets.filter(
                  (timesheet) =>
                    !data.some((existingTimesheet) => existingTimesheet.id === timesheet.id)
                );

                // Concatenate filtered new timesheets to existing data
                data = [...data, ...newTimesheet];

                // Increment PageNumber for the next iteration
                list.pageNumber = (list.pageNumber || 1) + 1; // Increment pageNumber for timesheets
              } else {
                // No more timesheets available, break out of the loop
                break;
              }
            } else {
              // Handle API error here
              throw new Error('Failed to fetch timesheets: ' + response.statusText);
            }
          } while (response.data.timesheets.length >= list.inputData.PageSize);

          // Update the response data with the aggregated timesheets data
          response.data.timesheets = data;
          return response;

        case 'leads':
          let data = [];

          do {
            response = await apiServices.getLeadList({
              ...list.inputData,
              PageNumber: list.pageNumber || 1, // Use the pageNumber property for leads
            });

            if (response.status === 200) {
              // Check if the response contains leads data
              if (response.data.leads && response.data.leads.length > 0) {
                // Filter out any leads that are already present in 'data'
                const newLeads = response.data.leads.filter(
                  (lead) => !data.some((existingLead) => existingLead.id === lead.id)
                );

                // Concatenate filtered new leads to the existing data
                data = [...data, ...newLeads];

                // Increment PageNumber for the next iteration
                list.pageNumber = (list.pageNumber || 1) + 1;
              } else {
                // No more leads available, break out of the loop
                break;
              }
            } else {
              // Handle API error here
              throw new Error('Failed to fetch leads: ' + response.statusText);
            }
          } while (response.data.leads.length >= list.inputData.pageSize);

          // Update the response data with the aggregated leads data
          response.data.leads = data;
          return response;
        case 'campaignList':
          let data1 = [];

          do {
            response = await apiServices.getCampaignList({
              ...list.inputData,
              PageNumber: list.pageNumber || 1, // Use the pageNumber property for leads
            });

            if (response.status === 200) {
              // Check if the response contains leads data
              if (response.data.campaign && response.data.campaign.length > 0) {
                // Filter out any leads that are already present in 'data'
                const newcampaigns = response.data.campaign.filter(
                  (campaign) =>
                    !data1.some((existingcampaign) => existingcampaign.id === campaign.id)
                );

                // Concatenate filtered new leads to the existing data
                data1 = [...data1, ...newcampaigns];

                // Increment PageNumber for the next iteration
                list.pageNumber = (list.pageNumber || 1) + 1;
              } else {
                // No more leads available, break out of the loop
                break;
              }
            } else {
              // Handle API error here
              throw new Error('Failed to fetch leads: ' + response.statusText);
            }
          } while (response.data.campaign.length >= list.inputData.pageSize);

          // Update the response data with the aggregated leads data
          response.data.campaign = data1;
          return response;

        default:
          return { data: [] };
      }
    } catch (error) {
      throw error;
    }
  }
);

export const updatePartialData = createAsyncThunk(
  'lists/updatePartialData',
  async (list, thunkAPI) => {
    //   try {
    //     return await apiServices.getSortedProjectList(list.inputData);
    //   } catch (error) {
    //     throw error;
    //   }
    try {
      switch (list.key) {
        case 'timesheets':
          const responseT = await apiServices.getSortedTimesheetList(list.inputData);
          return responseT;

        case 'assignments':
          const responseA = await apiServices.getSortedTaskList(list.inputData);
          return responseA;

        case 'projects':
          const responseP = await apiServices.getSortedProjectList(list.inputData);
          return responseP;

        case 'clients':
          const responseC = await apiServices.getClientList(list.inputData);
          return responseC;

        case 'leads':
          const responseL = await apiServices.getLeadList(list.inputData);
          return responseL;

        // case "accounts":
        //   const responseAC = await apiServices.getAccountList(list.inputData);
        //   return responseAC;

        default:
          return { data: [] };
      }
    } catch (error) {
      throw error;
    }
  }
);
const getTree = (moduleName, val) => {
  switch (moduleName) {
    case 'Lead':
      return [val, 'leads', 'leads'];
    case 'Opportunity':
      return [val, 'opportunityList', 'opportunity'];
    case 'Account':
      return [val, 'accountList', 'account'];
    case 'Campaign':
      return [val, 'campaignList', 'campaign'];
    case 'Contact':
      return [val, 'contactList', 'contacts'];
    case 'Ticket':
      return [val, 'ticketList', 'ticket'];
    case 'Meetings':
      return [val, 'meetingsList', 'meetings'];
    case 'Calls':
      return [val, 'callsList', 'calls'];
    case 'Quote':
      return [val, 'quoteList', 'quote'];
    case 'Product':
      return [val, 'productList', 'product'];

    case 'SaleOrder':
      return [val, 'salesOrder', 'saleOrders'];
    case 'Invoice':
      return [val, 'invoice', 'invoices'];
    case 'PriceSheet':
      return [val, 'priceSheetList', 'priceSheet'];

    case 'SmartSequence':
      return [val, 'smartSequence', 'sequenceDetailsList'];

    default:
      return [val];
  }
};

// Generalized fetch and append thunk
const createFetchAndAppendThunk = (actionName, apiServiceMethod, listKey) =>
  createAsyncThunk(actionName, async (data, thunkAPI) => {
    try {
      const list = await apiServiceMethod(data);
      const tree = getTree(data?.moduleName, data?.id);
      return { tree, [listKey]: list }; // Dynamic key for the returned list
    } catch (error) {
      throw error;
    }
  });

// Optimized singleRowAddUpdateInStore and fetchDetailAndAppendToModule

const moduleApiMap = {
  Lead: apiServices.getLeadById,
  Contact: apiServices.getContactById,
  Account: apiServices.getAccountById,
  Ticket: apiServices.getTicketById,
  Opportunity: apiServices.getOpportunityById,
};

// export const singleRowAddUpdateInStore = createAsyncThunk(
//   "lists/singleRowAddUpdateInStore",
//   async (list, thunkAPI) => {
//     const apiFn = moduleApiMap[list.moduleName];
//     if (apiFn) {
//       const response = await apiFn(list.id);
//       return getTree(list.moduleName, response);
//     }
//     return { data: [] };
//   }
// );

export const fetchDetailAndAppendToModule = createAsyncThunk(
  'lists/fetchDetailAndAppendToModule',
  async (list, thunkAPI) => {
    try {
      switch (list?.moduleName) {
        // case "Lead": {
        //   const leadData = list?.localDetail
        //     ? list?.localDetail
        //     : await apiServices.getLeadById(list.id);
        //   return getTree(list.moduleName, leadData);
        // }
        case 'Lead': {
          const leadData = list?.localDetail ? null : await apiServices.getLeadById(list.id);
          return getTree(list.moduleName, leadData);
        }
        case 'Contact': {
          const contactData = list?.localDetail ? null : await apiServices.getContactById(list.id);
          return getTree(list.moduleName, contactData);
        }
        case 'Account': {
          const accountData = list?.localDetail ? null : await apiServices.getAccountById(list.id);
          return getTree(list.moduleName, accountData);
        }
        case 'Opportunity': {
          const opportunityData = list?.localDetail
            ? null
            : await apiServices.getOpportunityById(list.id);
          return getTree(list.moduleName, opportunityData);
        }
        case 'Campaign': {
          const campaignData = list?.localDetail
            ? null
            : await apiServices.getCampaignById(list.id);
          return getTree(list.moduleName, campaignData);
        }
        case 'Ticket': {
          const ticketData = list?.localDetail ? null : await apiServices.getTicketById(list.id);
          return getTree(list.moduleName, ticketData);
        }
        case 'SaleOrder': {
          const salesOrderData = list?.localDetail
            ? null
            : await apiServices.getSalesOrderById(list.id);
          return getTree(list.moduleName, salesOrderData);
        }
        case 'Quote': {
          const quoteData = list?.localDetail ? null : await apiServices.getQuoteById(list.id);
          return getTree(list.moduleName, quoteData);
        }
        case 'Product': {
          const productData = list?.localDetail ? null : await apiServices.getProductById(list.id);
          return getTree(list.moduleName, productData);
        }
        case 'PriceSheet': {
          const priceSheetData = list?.localDetail
            ? null
            : await apiServices.getPriceListById(list.id);
          return getTree(list.moduleName, priceSheetData);
        }
        case 'Invoice': {
          const invoiceData = list?.localDetail ? null : await apiServices.getInvoiceById(list.id);
          return getTree(list.moduleName, invoiceData);
        }
        default:
          return { data: [] };
      }
      return { data: [] };
    } catch (error) {
      throw error;
    }
  }
);

// Specific thunks using the generalized function
export const fetchNotesAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchNotesAndAppendToModule',
  apiServices.getNotesByModuleId,
  'notesList'
);

export const fetchAttachmentsAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchAttachmentsAndAppendToModule',
  apiServices.getAttachmentsByModuleId,
  'attachmentsList'
);

export const fetchCampaignsAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchCampaignsAndAppendToModule',
  apiServices.getCampaignsByModuleId,
  'campaignsList'
);

export const fetchLeadsAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchLeadsAndAppendToModule',
  apiServices.getLeadsByCampaignId,
  'LeadList'
);

export const fetchContactsAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchContactsAndAppendToModule',
  apiServices.getContactsByCampaignId,
  'contactList'
);

export const fetchEmailAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchEmailAndAppendToModule',
  apiServices.getEmailsByModuleId,
  'emailList'
);

export const fetchTagsAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchTagsAndAppendToModule',
  apiServices.getTagsByModuleId,
  'tagsList'
);

export const fetchQuoteItemsAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchQuoteItemsAndAppendToModule',
  apiServices.getQuoteDetailsByQuoteId,
  'quoteDetails'
);

export const fetchAccountsAndAppendToProduct = createFetchAndAppendThunk(
  'lists/fetchAccountsAndAppendToProduct',
  apiServices.getAccountsByProductId,
  'accountList'
);

export const fetchAccountsAndAppendToPriceSheet = createFetchAndAppendThunk(
  'lists/fetchAccountsAndAppendToPriceSheet',
  apiServices.getAccountByPricesheetId,
  'accountList'
);

export const fetchProductsAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchProductsAndAppendToModule',
  apiServices.getProductByPricesheetId,
  'productList'
);

export const fetchSelectedListAndAppendToModule = createAsyncThunk(
  'lists/fetchSelectedListAndAppendToModule',
  async (list, thunkAPI) => {
    return list;
  }
);

export const singleRowAddUpdateInStore = createAsyncThunk(
  'lists/singleRowAddUpdateInStore',
  async (list, thunkAPI) => {
    switch (list.moduleName) {
      case 'Lead': {
        const response = await apiServices.getLeadById(list.id);
        return getTree(list.moduleName, response);
      }
      case 'Contact': {
        const response = await apiServices.getContactById(list.id);
        return getTree(list.moduleName, response);
      }
      case 'Account': {
        const response = await apiServices.getAccountById(list.id);
        return getTree(list.moduleName, response);
      }
      case 'Campaign': {
        const response = await apiServices.getCampaignById(list.id);
        return getTree(list.moduleName, response);
      }
      case 'Ticket': {
        const response = await apiServices.getTicketById(list.id);
        return getTree(list.moduleName, response);
      }
      case 'Opportunity': {
        const response = await apiServices.getOpportunityById(list.id);
        return getTree(list.moduleName, response);
      }
      case 'SaleOrder': {
        const response = await apiServices.getSalesOrderById(list.id);

        return getTree(list.moduleName, response);
      }
      case 'Invoice': {
        const response = await apiServices.getInvoiceById(list.id);
        return getTree(list.moduleName, response);
      }
      case 'Quote': {
        const response = await apiServices.getQuoteById(list.id);
        return getTree(list.moduleName, response);
      }
      case 'Product': {
        const response = await apiServices.getProductById(list.id);
        return getTree(list.moduleName, response);
      }
      case 'PriceSheet': {
        const response = await apiServices.getPriceListById(list.id);
        return getTree(list.moduleName, response);
      }

      case 'SmartSequence': {
        const response = await apiServices.getSmartSequenceById({ id: list.id });
        return getTree(list.moduleName, response);
      }
      default:
        return { data: [] };
    }
  }
);
export const fetchSalesOrderedItemAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchSalesOrderedItemAndAppendToModule',
  apiServices.getSalesOrderDetailsById,
  'salesOrderedItemList'
);

export const fetchInvoiceSalesOrderedItemAndAppendToModule = createFetchAndAppendThunk(
  'lists/fetchInvoiceSalesOrderedItemAndAppendToModule',
  apiServices.getInvoiceSalesOrderDetails,
  'invoiceSalesOrderedItemList'
);
